var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"box"}),(_vm.dialogFormVisible)?_c('el-dialog',{attrs:{"title":"管理图片","visible":_vm.dialogFormVisible,"custom-class":"dialog","width":"740px"},on:{"update:visible":function($event){_vm.dialogFormVisible=$event}}},[_c('FileUpload',{attrs:{"chooseNum":10,"chooseFunc":_vm.fileChoose}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }